export { editTopicResource } from './resources';
